import { useRecoilValue } from "recoil";
import { camState, deviceListState, micState } from "../../../recoil/record";

const NoCameraDetected = () => {
  const deviceList = useRecoilValue(deviceListState);
  return (
    <>
      {!deviceList ||
        (deviceList?.filter((device) => {
          return device.kind === "videoinput";
        }).length === 0 && (
          <div className="warning-alert">
            <p className="warning-title">
              카메라 없이 테스트에 참여 되었습니다.
            </p>
            <p className="warning-step">
              장치 선택은 크롬 오른쪽 상단 '설정' → '개인정보 및 보안'
              <br /> → '사이트 설정' → '카메라', '마이크' 에서 하세요.
            </p>
          </div>
        ))}
    </>
  );
};

export default NoCameraDetected;
